type TutorWhiteboardToggleProps = {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  variant?: "default" | "ecole" | "liceo";
};

export function TutorWhiteboardToggle({
  checked,
  onCheckedChange,
  variant = "default",
}: TutorWhiteboardToggleProps) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label="Tutor may suggest visual exercises"
      onClick={(event) => {
        event.stopPropagation();
        onCheckedChange(!checked);
      }}
      className="group flex w-full items-center justify-between gap-4 rounded-lg border border-white/10 bg-black/25 px-3 py-2.5 text-left transition-colors hover:border-white/20 hover:bg-white/[0.04] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-orange-300/60"
    >
      <span className="min-w-0">
        <span className="flex items-center gap-2">
          <span className="text-sm font-semibold text-white">
            Tutor may suggest visual exercises
          </span>
          <span className="rounded border border-orange-300/35 bg-orange-500/10 px-1.5 py-0.5 text-[9px] font-black uppercase tracking-[0.14em] text-orange-200">
            Beta
          </span>
        </span>
        <span className="mt-0.5 block text-xs leading-snug text-zinc-500">
          Let Chicky add them naturally during this session.
        </span>
      </span>
      <span
        aria-hidden="true"
        className={`relative inline-flex h-6 w-11 shrink-0 items-center rounded-full border transition-colors ${
          checked
            ? variant !== "default"
              ? "border-school-accent/60 bg-school-blue"
              : "border-orange-300/70 bg-orange-500"
            : "border-white/15 bg-zinc-800"
        }`}
      >
        <span
          className={`block h-4 w-4 rounded-full bg-white shadow-sm transition-transform ${
            checked ? "translate-x-6" : "translate-x-1"
          }`}
        />
      </span>
    </button>
  );
}
